import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c43c016"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headline-section__tag profile-tag responsive-content" }
const _hoisted_2 = { class: "profile-tag__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headline_selection = _resolveComponent("headline-selection")!
  const _component_headline_side = _resolveComponent("headline-side")!
  const _component_step = _resolveComponent("step")!

  return (_openBlock(), _createBlock(_component_step, {
    "is-step-valid": _ctx.hasValidFieldPart,
    onGoToNext: _ctx.goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.headline.tagline')), 1)
      ]),
      _createVNode(_component_headline_selection, {
        title: _ctx.$msg('profile.creation.predictor.wizard.details.headline.title'),
        "subtitle-help": _ctx.$msg('profile.creation.predictor.wizard.details.headline.help'),
        onHeadlineKeypressEnter: _ctx.headlineKeypressEnter
      }, null, 8, ["title", "subtitle-help", "onHeadlineKeypressEnter"])
    ]),
    "step-side": _withCtx(() => [
      _createVNode(_component_headline_side)
    ]),
    _: 1
  }, 8, ["is-step-valid", "onGoToNext"]))
}